export const firebaseConfig = {
  apiKey: "AIzaSyBM2vEOpyrdWoMuL6yfyh2xbUs-cfTbdJU",
  authDomain: "stronghold-db.firebaseapp.com",
  databaseURL: "https://stronghold-db.firebaseio.com",
  projectId: "stronghold-db",
  storageBucket: "stronghold-db.appspot.com",
  messagingSenderId: "764812315354",
  appId: "1:764812315354:web:e75055283060267333f3e3",
};
